import type { HardnessLevel, HardnessTraceStep } from '~api/services';
import { getHardnessColour } from '~config/hardness';

type HardnessRuleState = 'not-evaluated' | 'error' | 'skipped' | 'completed' | 'evaluated';

/** Builds a lookup table for matching ruleset entries to trace steps by rule name. */
const getHardnessRuleStepByName = (steps: HardnessTraceStep[]): Map<string, HardnessTraceStep> => {
  return new Map(steps.map((step) => [step.name, step]));
};

/** Determines the display state for a hardness rule based on its optional trace step. */
const getHardnessRuleState = (step?: HardnessTraceStep): HardnessRuleState => {
  if (!step) return 'not-evaluated';
  if (step.result.error != null) return 'error';
  if (step.result.skipped) return 'skipped';
  if (step.result.completes === true) return 'completed';

  return 'evaluated';
};

/** Resolves the text colour for a hardness value with a safe fallback. */
const getHardnessTextColour = (hardness?: HardnessLevel | null): string => {
  if (!hardness) return 'var(--foreground)';

  return getHardnessColour(hardness).fill;
};

export { getHardnessRuleState, getHardnessRuleStepByName, getHardnessTextColour, type HardnessRuleState };
